export const USER_ROLE = {
    salesRepresentative: 'Sales Rep',
    LSA: 'LSA',
    Instructor: 'Instructor'
};

export const SEARCH_OPTIONS = {
    FILTER : 'Please select the filter option',
    RESOURCEID : 'Please enter the resource id',
    RESOURCEIDLIST : 'Please enter the resource ids seperated by comma',
    FILENAME  : 'Please enter the file name',
    ISBN : 'Please enter list of ISBNs seperated by comma',
    FILENAMELIST : 'Please enter list of Filenames seperated by comma',
    EPSID : 'Please enter the EPS IDs seperated by comma',
    ASSETTITLE : 'Please enter the Asset Title',
    TITLE : 'Please enter the Title',
    COLLECTIONID : 'Please enter the Collection Id',
    TAXONOMY : 'Please enter the Taxonomy'

};

export const MESSAGE_TYPES = {
    default: {styleClass:'message_default',icon: false},
    error: {styleClass:'message_error',icon: 'warning-18'},
    warning: {styleClass:'message_warning',icon: 'warning-18'},
    success: {styleClass:'message_success',icon: 'check-lg-18'},
    info: {styleClass:'message_info',icon: false},
};

export const TEXT_TYPES = {
    RESOURCE_METADATA: "Resource metadata",
    IMPORT_CC_COLLECTION: "Import and Create a Curated Collection",
    CC_CREATION_STATUS: "Curated Collection Creation Status",
    CC_MIGRATION_STATUS: "Curated Collection Migration Status",
    PRICE_UPDATE_STATUS: "Price Update Status",
    CC_COLLECTION_NOTE: "Hint: Click on the Select button and select a .xls/.xlsx file to import Curated Collections",
    UPLOAD_FILE_CONFIRMATION : "Upload File Confirmation",
    UPLOAD_FILE_CONFIRMATION_MSG : "Are you sure you want to Upload this file ?",
    UPLOAD_FILE_COMPLETE_MSG : "Batch ID Info",
    UPLOAD_BATCH_INFO_MSG : "Batch Id for your Transaction is: ",
    VIEW_STATUS_MSG : " View status here.",
    SUCCESS_MSG : "Success.",
    FAILED_MSG : "Failed.",
    UPLOAD_CONTENT: "Upload Content",
    UPLOAD_METADATA: "Upload Metadata",
    SELECT_METADATA_NOTE: "Hint: Select Content Type and Source",
    UPLOAD_CONTENT_NOTE: "Hint: Select New Upload or ReplacePDF to upload content. Accepted extensions are .PDF and .pdf",
    UPLOAD_METADATA_NOTE: "Hint: Click on the Add Files button and look for some metadata to upload. Accepted extensions are .XLS and .XLSX",
    CONTENT_TYPE: "Content Type",
    SOURCE: "Source",
    RESOURCE_NAME: "Resource Name",
    UPLOAD_STATUS: "Upload Status",
    UPLOAD_CONTENT_CONFIRMATION: "Upload Content(s) Confirmation",
    UPLOAD_METADATA_CONFIRMATION: "Upload Metadata(s) Confirmation",
    UPLOAD_SUMMARY: "Upload Summary",
    UPLOAD_METADATA_CONFIRMATION_MSG: "You are about to upload $file. Do you wish to continue?",
    UPLOAD_CONTENT_CONFIRMATION_MSG: "You are about to upload pdf file(s). Do you wish to continue?",
    UPLOAD_METADATA_SUCCESS_MSG: "Your file - $file is being uploaded. The batch id is - $batchId",
    CONTENT_TYPE_TEXTS: "Texts",
    CONTENT_TYPE_CASES: "Cases",
    SCRUBBED: "scrubbed",
    CC_DELETION_NOTE: "Hint: Click on the Select button and select a .xls/.xlsx file to import Curated Collections to be Deleted.",
    VIEW_LOGS: "View Logs",
    UPLOAD_PROGRESS: "Upload Progress",
    FILE_NAME: "File Name",
    CONTENT_UPDATE_STATUS: "Content Update Status",
    METADATA_UPDATE_STATUS: "Metadata Update Status",
    VIEW_BATCH_DETAILS: "View Batch Details",
    CC_DELETION_STATUS: "Curated Collection Deletion Status",
    EDIT_CONTENT_MANAGEMENT: "Edit Content Management",
    UPDATE_METADATA: "Update Metadata",
    UPDATE_METADATA_CONFIRMATION: "You have selected to update the attributes listed below. Please review and click the OK button if everything is correct, otherwise click the Cancel button.",
    RESOURCE_NOT_FOUND: "Resource not found or there were some other issues while searching.",
    CURATED_SEARCH: "Curated Search",
    PRICE_CALCULATION: "Calculate Price for ISBN"
};

export const METADATA_VALIDATION_ERRORS = {
    IS_REQUIRED: "Field is required.",
    DATA_TOO_LONG: "Entered data is too long.",
    INVALID_NUMBER: "Invalid number.",
    INVALID_DATE: "Invalid date.",
    NUMBER_TOO_LARGE: "Number too large."
};



// WEBPACK FOOTER //
// ./src/constants/APP_CONSTANTS.js